import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Entity } from '@debbie/common/dist/index.js';
import { PropertyDataType } from '@debbie/common/dist/properties/index.js';
import { properties as propertiesAPI } from '@debbie/cortex/dist/api/index.js';
import { Select, Textarea, Checkbox, Well, Input, Button, ButtonGroup, SearchInput, } from '../index.js';
import PropertyTypeInfo from './PropertyTypeInfo.js';
import { useCaseGroups } from '@debbie/cortex/dist/caseGroups/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import { propertyTypesKey } from '@debbie/cortex/dist/properties/index.js';
const NewPropertyTypeCMP = (props) => {
    const lang = useSelector((s) => s.lang);
    const caseGroupsLoadable = useCaseGroups();
    const caseGroups = h.hasData(caseGroupsLoadable)
        ? caseGroupsLoadable.data
        : null;
    const [dropdownOptions, setDropdownOptions] = useState(`Option 1
Option 2`);
    const [selectedCaseGroup, setCaseGroup] = useState(null);
    const [loadingNewPropertyType, setLoadingNewPropertyType] = useState(false);
    const [newPropertyType, setNewPropertyType] = useState({
        data: {},
        handle: '',
        label: '',
        description: '',
        type: PropertyDataType.singleLineText,
        required: false,
        scope: null,
        scopeId: null,
        ref: Entity.Case,
    });
    const options = dropdownOptions.split(`\n`).filter((option) => option.trim());
    const addNewPropertyType = async () => {
        setLoadingNewPropertyType(true);
        try {
            await propertiesAPI.createType({
                data: newPropertyType.type === PropertyDataType.dropdown
                    ? {
                        options: options.map((option) => ({
                            value: option,
                            text: option,
                        })),
                    }
                    : null,
                description: newPropertyType.description,
                handle: newPropertyType.handle,
                type: newPropertyType.type,
                label: newPropertyType.label,
                scope: newPropertyType.scope,
                scopeId: newPropertyType.scopeId,
                permissionLevel: 'caseworker',
                permissionLevelEdit: 'caseworker',
                ref: newPropertyType.ref,
                required: newPropertyType.required,
            });
            q.invalidate([propertyTypesKey]);
            props.onAdd && props.onAdd();
        }
        catch (error) {
            console.error(error);
            alert('Error');
        }
        setLoadingNewPropertyType(false);
    };
    return (React.createElement(PropertiesStyled, null,
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { size: "small", onClick: () => setNewPropertyType({
                    ...newPropertyType,
                    ref: Entity.Case,
                    scope: null,
                    scopeId: null,
                }), theme: newPropertyType.ref === Entity.Case ? undefined : 'secondary' }, "Sag"),
            React.createElement(Button, { size: "small", onClick: () => setNewPropertyType({
                    ...newPropertyType,
                    ref: Entity.CaseVoucher,
                    scope: null,
                    scopeId: null,
                }), theme: newPropertyType.ref === Entity.CaseVoucher ? undefined : 'secondary' }, "Sagspostering"),
            React.createElement(Button, { size: "small", onClick: () => setNewPropertyType({
                    ...newPropertyType,
                    ref: Entity.Creditor,
                    scope: null,
                    scopeId: null,
                }), theme: newPropertyType.ref === Entity.Creditor ? undefined : 'secondary' }, "Kreditor")),
        React.createElement("br", null),
        React.createElement("br", null),
        [Entity.Case, Entity.CaseVoucher].includes(newPropertyType.ref) && (React.createElement(SearchInput, { onSelect: (_caseGroup) => {
                setNewPropertyType({
                    ...newPropertyType,
                    scope: 'case_groups',
                    scopeId: _caseGroup.id,
                });
                setCaseGroup(_caseGroup);
            }, forceOpen: true, placeholder: lang.cases.caseGroup, static: selectedCaseGroup && selectedCaseGroup.label, onRemoveStatic: () => {
                setNewPropertyType({
                    ...newPropertyType,
                    scope: null,
                    scopeId: null,
                });
                setCaseGroup(null);
            }, searchAll: (q) => caseGroups
                ? caseGroups
                    .map((caseGroup) => ({
                    returnData: caseGroup,
                    heading: caseGroup.label,
                    key: caseGroup.id,
                }))
                    .filter((d) => !q ||
                    JSON.stringify(d)
                        .toLocaleLowerCase()
                        .indexOf(q.toLocaleLowerCase()) !== -1)
                    .slice(0, 20)
                : [] })),
        React.createElement(Input, { placeholder: lang.properties.label, onChange: (e) => {
                setNewPropertyType({
                    ...newPropertyType,
                    label: e.target.value,
                });
            }, value: newPropertyType.label }),
        React.createElement(Textarea, { placeholder: lang.properties.description, onChange: (e) => {
                setNewPropertyType({
                    ...newPropertyType,
                    description: e.target.value,
                });
            }, value: newPropertyType.description }),
        React.createElement(Input, { placeholder: lang.properties.handle, pattern: "[a-z0-9_]", onChange: (e) => {
                const reg = e.target.value.match(/[a-z0-9]+/g);
                setNewPropertyType({
                    ...newPropertyType,
                    handle: reg && reg[0] ? reg[0] : '',
                });
            }, value: newPropertyType.handle, validationErrors: !newPropertyType.handle || isNaN(newPropertyType.handle)
                ? null
                : ['Invalid - cant be a number'] }),
        React.createElement(Checkbox, { placeholder: lang.properties.required, onChange: (e) => {
                const reg = e.target.value.match(/[a-z0-9]+/g);
                setNewPropertyType({
                    ...newPropertyType,
                    required: e.target.checked,
                });
            }, checked: newPropertyType.required }),
        React.createElement("br", null),
        React.createElement(Select, { value: newPropertyType.type, onChange: (e) => {
                setNewPropertyType({
                    ...newPropertyType,
                    type: e.target.value,
                });
            } }, Object.values(PropertyDataType).map((type) => (React.createElement("option", { key: type, value: type }, type)))),
        newPropertyType.type === PropertyDataType.dropdown && (React.createElement(Textarea, { placeholder: lang.properties.dropdownOptions, value: dropdownOptions, onChange: (e) => {
                setDropdownOptions(e.target.value);
            } })),
        newPropertyType.handle && (React.createElement(React.Fragment, null,
            React.createElement(Well, null,
                React.createElement(PropertyTypeInfo, { property: newPropertyType })),
            React.createElement("br", null))),
        React.createElement(Button, { onClick: addNewPropertyType, loading: loadingNewPropertyType, disabled: !(newPropertyType.label &&
                newPropertyType.handle &&
                newPropertyType.description &&
                newPropertyType.type &&
                (newPropertyType.type !== PropertyDataType.dropdown ||
                    (newPropertyType.type === PropertyDataType.dropdown &&
                        options.length > 0))) }, lang.properties.create)));
};
export default NewPropertyTypeCMP;
const PropertiesStyled = styled.div ``;
//# sourceMappingURL=NewPropertyType.js.map